import { css } from 'styled-components'

export const flexCenter = css`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const mainAppBarTool = css`
  margin-left:  -12px;
  margin-right: 20px;
`



// WEBPACK FOOTER //
// ./src/project-utils/common-styles.ts